import { View, Text, Image } from 'src/components/common';
import { connect } from 'react-redux';
import 'src/components/DepositionDetailItem/InvolvedParties/styles.scss';
import { IAppState } from 'src/store';
import { People } from 'src/dataFactory/depositionFactory';
import { getUserPositionDisplay } from 'src/utils';
const RequestedBy: React.FC<Props> = ({ user }) => {
  return (
    <View className={'cmp-deposition-detail'} isRow>
      <Image src={user?.imageURL} className="cmp-deposition-detail__image" />
      <View className={'cmp-deposition-detail__image--with-text'}>
        <Text className={'cmp-deposition-detail__name'} title={user?.name}>
          {user?.name}
        </Text>
        <Text className={'cmp-deposition-detail__position'}>{getUserPositionDisplay(user?.position ?? '')}</Text>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    user?: People;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RequestedBy);
